(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[838],{

/***/ 4862:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artworks/[id]",
      function () {
        return __webpack_require__(9315);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _features_pages_ArtworkDetailPage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6089);
/* harmony import */ var _features_pages_ArtworksErrorPage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8591);




const ArtworkDetail = (param)=>{
    let { artworkDetails , relatedArtworks , errorCode , gallery  } = param;
    if (errorCode && errorCode !== 200) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_pages_ArtworksErrorPage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        status: errorCode,
        artwork: artworkDetails,
        gallery: gallery
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_pages_ArtworkDetailPage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        artworkDetails: artworkDetails,
        relatedArtworks: relatedArtworks,
        gallery: gallery
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ArtworkDetail);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [144,686,233,717,774,888,179], function() { return __webpack_exec__(4862); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);